import {Component} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import {ActivatedRoute, Router, Params } from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";
import {DialogService} from "../services/dialog.service";

@Component({
  selector: 'micro-reactor-detail',
  templateUrl: './reactor-detail.component.html'
})
export class ReactorDetailComponent extends BaseComponent {
  reactor:any;
  selectedEvent:any;
  reactorTestResult:any;
  testing:boolean = false;
  apiKeySelectedAuths:string[] = [];

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              private dialogService:DialogService,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/reactor/reactors/${id}`).subscribe(
            data => {
              this.setReactor(data as any);
            }
          );
        }
      });
  }

  createNew() {
    this.setReactor({
      auths: {},
      groups: [],
      eventFilter: 'false'
    });
  }

  save() {
    this.removeAuths("API_KEY");
    if (this.reactor.eventType === 'reactor_webhook') {
      this.setAuths("API_KEY", this.apiKeySelectedAuths);
    }

    if (!this.reactor.id) {
      this.http.post(`${this.env.e.url}/reactor/reactors`, this.reactor)
        .subscribe(
          data => {
            this.setReactor(data as any);
            this.alertService.info(`Created ${this.reactor.name}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/reactor/reactors/${this.reactor.id}`, this.reactor)
        .subscribe(
          data => {
            this.setReactor(data as any);
            this.alertService.info(`Updated Reactor Settings`);
          }
        );
    }
  }

  setReactor(data:any) {
    this.reactor = data;
    const auths = this.reactor.auths
    for (const dataKey in auths) {
      if (auths[dataKey] === "API_KEY")
        this.apiKeySelectedAuths.push(dataKey);
    }
  }

  removeAuths(authType:string) {
    const auths = this.reactor.auths;
    for (const dataKey in auths) {
      if (auths[dataKey] === authType)
        delete this.reactor.auths[dataKey];
    }
  }

  setAuths(authType:string, selectedIds:string[]) {
    const auths = this.reactor.auths;
    selectedIds.forEach(id => {
      this.reactor.auths[id] = authType;
    });
  }

  generateEventSource(): void {
    this.reactor.eventSource = this.newEventSource();
  }

  copyClipboard(value, what: string | undefined): void {
    let alertMsg = what ? what + ' copied to clipboard' : 'Copied to clipboard';
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(value.toString())
        .then(() => this.alertService.info(alertMsg))
        .catch(() => this.copyClipboardFallback(value.toString(), what));
    } else {
      this.copyClipboardFallback(value.toString(), what);
    }
  }

  private copyClipboardFallback(value: string, what: string | undefined): void {
    let alertMsg = what ? what + ' copied to clipboard' : 'Copied to clipboard';
    const input = document.createElement('textarea');
    input.value = value;
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();

    try {
      if (document.execCommand('copy')) {

        this.alertService.info(alertMsg);
      } else {
        this.alertService.warn('Could not copy to clipboard');
      }
    } finally {
      document.body.removeChild(input);
    }
  }

  private newEventSource(): string {
    const bytes = new Uint8Array(16);
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
      crypto.getRandomValues(bytes);
    } else {
      for (let i = 0; i < bytes.length; i++) {
        bytes[i] = Math.floor(Math.random() * 256);
      }
    }

    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
  }

  delete() {
    this.http.delete(`${this.env.e.url}/reactor/reactors/${this.reactor.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted Reactor ${this.reactor.name}`);
          this.router.navigate(["/reactors"]);
        }
      );
  }

  pickTestEvent() {
    this.dialogService.pickEvent({eventType: this.reactor.eventType, eventSource: this.reactor.eventSource}).subscribe(res =>{
      if (res.confirmed) {
        this.selectedEvent = res.event;
      }
    });
  }

  test() {
    let req = {
      reactor: this.reactor,
      event: this.selectedEvent
    };
    this.testing = true;
    this.http.post(`${this.env.e.url}/reactor/reactors/test`, req)
      .subscribe(
        data => {
          this.setTestResult(data);
          this.testing = false;
        }
      );
  }

  setTestResult(data) {
    this.reactorTestResult = data;
  }

  hasRole(role:string) {
    if (!role) {
      return true;
    }
    return this.authService.hasRole(role);
  }

  onEventTypeChange() {
    this.selectedEvent = null
    this.reactor.eventSource = undefined;
  }

  onCompanyIdChange() {
  }

  getWebhookUrl() {
    return `${this.env.config.url.replace(/\/+$/, "")}${this.env.e.url.replace(/\/+$/, "")}/reactor/webhooks/json/{syncMode}/${this.reactor.eventSource}/{api_key}`;
  }
}
